import React from 'react'

const CheckmarkIcon = ({ width, height, fill}) => (
    <svg 
        width={width}
        height={height}
        viewBox="0 -2.5 18 18" 
        id="meteor-icon-kit__solid-checkmark-s" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M3.06066 4.93934C2.47487 4.35355 1.52513 4.35355 
                0.93934 4.93934C0.35355 5.5251 0.35355 6.4749 0.93934 
                7.0607L5.93934 12.0607C6.52513 12.6464 7.4749 12.6464 
                8.0607 12.0607L17.0607 3.06066C17.6464 2.47487 17.6464 
                1.52513 17.0607 0.93934C16.4749 0.35355 15.5251 0.35355 
                14.9393 0.93934L7 8.8787L3.06066 4.93934z" 
                fill={fill}>
            </path>
        </g>
    </svg>
)

export default CheckmarkIcon
